import {createSelector} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";


export const selectState = (state: IgenomicsState) => state;

export const getActiveKnowledgeBase = createSelector(selectState,
  (state) => state.curation.activeKnowledgeBase);

